import type { FaireProductEntity } from "../../entity_types/product";

export const p_aghpusnncm: FaireProductEntity = {
  token: "p_aghpusnncm",
  type: "product",
  name: "Total Basket Case Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/fb873e679777ad377ea30ab45bf8829655ea0a9ad537019405766d13cf8cf7f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45277c1d8decb8e9e8d497c93f80eacc7fa0fb98695068d23bdd253442cc6de3.jpeg",
    "https://cdn.faire.com/fastly/8e9cd6092ae96bd3429c0cd7b9e35724b80ac6e0c93c4038e18c21768e0e4055.jpeg",
    "https://cdn.faire.com/fastly/41e7efcf1b53fe6cf686499e87ef466c6b8d59a3bf7ecc6c242dc82582e2b758.jpeg",
    "https://cdn.faire.com/fastly/f996fd08c1020668047f829c977a2e7718c8cf4c325b79c03c85c8f5cc3a3c40.jpeg",
    "https://cdn.faire.com/fastly/8cff9ee611d9899e06ed4cd162c24e9c60c4921525043dd37bb726d8f3451b4c.jpeg",
    "https://cdn.faire.com/fastly/889d43e4d8a6329368cfff35ae663b2f32cb2dbac2e2042be5f5d6c02f6057a0.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Easter & Spring Collection featuring an all-over design displaying a pattern of Easter egg baskets with a funny seasonal sentiment that reads \"Total Basket Case!\" Easter pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating zigzag pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Total Basket Case kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun Easter kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:22.914Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
